export { Video } from './Video';



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/components/Video/index.js